import * as React from "react";
import { SpinnerWithBackdrop } from "../SpinnerWithBackdrop";
import { Eula } from "./Eula";
import { useEula } from "./useEula";

interface Props {
  children: React.ReactNode;
}

export const WithEulaAcceptance = ({ children }: Props) => {
  const { isAccepted, isLoading, isError } = useEula();

  // If the EULA fetch failed (e.g. auth error), render children so the
  // reauth modal from ApiProvider can appear instead of a blank screen.
  if (isError) {
    return <>{children}</>;
  }

  if (isLoading) {
    return <SpinnerWithBackdrop />;
  }

  // If EULA is not accepted and we have EULA data, show the EULA dialog
  if (!isAccepted) {
    return <Eula />;
  }

  // Otherwise, render the children
  return <>{children}</>;
};
